import useSWRImmutable from 'swr/immutable'
import { endpoints, request } from '.'

export const useCtas = () => {
  const { data, isLoading, isValidating, error } = useSWRImmutable(
    endpoints.ctas.read(),
    request,
  )

  return {
    data: data?.data?.data,
    isLoading,
    isValidating,
    error,
  }
}
